export const INITIAL_SPECIES_REQUEST = "INITIAL_SPECIES_REQUEST";
export const FETCH_SPECIES_SUCCESS = "FETCH_SPECIES_SUCCESS";
export const FINAL_SPECIES_REQUEST = "FINAL_SPECIES_REQUEST";
